import styled from 'styled-components'

export const NotificationContainer = styled.div`
  margin-bottom: 20px;
`
